import { Box, Container, Grid, GridItem, Image, Text } from "@chakra-ui/react";
import Partner1 from "common/assets/img/partner1.png";
import Partner2 from "common/assets/img/partner2.png";
import Partner3 from "common/assets/img/partner3.png";
import Partner4 from "common/assets/img/partner4.png";
import Partner5 from "common/assets/img/partner5.png";
import { landingPageConstants } from "common/landingPageConstants";

const Parntenrs = () => {
  return (
    <>
      <Container maxW="container.xl">
        <Box className="partnersSection">
          <Grid templateColumns={{ md: "repeat(3, 1fr)" }} gap={"20px"}>
            <GridItem colSpan={1}>
              <Box className="partnersTitle">
                <Text className="partnerSectionTitle">
                  {landingPageConstants.trustedBy}{" "}
                  <span className="ctaColor">17k</span>{" "}
                  {landingPageConstants.partnersTitle}
                </Text>
              </Box>
            </GridItem>
            <GridItem colSpan={2}>
              <Grid
                templateColumns={{base:"repeat(2, 1fr)", md:"repeat(auto-fit, minmax(180px, 1fr))", lg:"repeat(auto-fit, minmax(180px, 1fr))"}}
                justifyItems="center"
                alignItems="center"
              >
                {[Partner1, Partner2, Partner3, Partner4].map((logo, index) => (
                  <GridItem key={index}>
                    <Box className="partnerImg">
                      <Image
                        src={logo}
                        width="112px"
                        alt={`Partner logo ${index + 1}`}
                      />
                    </Box>
                  </GridItem>
                ))}
              </Grid>
            </GridItem>
          </Grid>
        </Box>
      </Container>
    </>
  );
};
export default Parntenrs;
